// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    userId: z.string().min(1).max(128),
    organizationId: z.string().max(21).nullable().optional(),
    revision: z.number().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    userId: z.string().min(1).max(128),
    organizationId: z.string().max(21).nullable(),
    revision: z.number(),
});
export const UserOrganizationIdentities = Object.freeze({
    table: 'user_organization_identities',
    tableSingular: 'user_organization_identity',
    fields: {
        tenantId: 'tenant_id',
        userId: 'user_id',
        organizationId: 'organization_id',
        revision: 'revision',
    },
    fieldKeys: [
        'tenantId',
        'userId',
        'organizationId',
        'revision',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
